import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface Customer {
  id: string;
  label: string;
  providerId: string;
}

export function useCustomers() {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    supabase
      .from("customers")
      .select("id, label, provider_id")
      .order("label")
      .then(({ data, error }) => {
        if (error) {
          setError(error.message);
          setCustomers([]);
        } else {
          setCustomers(
            data.map((customer) => ({
              id: customer.id,
              label: customer.label,
              providerId: customer.provider_id,
            })) || [],
          );
        }
        setIsLoading(false);
      });
  }, []);

  return { customers, isLoading, error };
}
